module.exports = __webpack_public_path__ + "static/media/calc.1515016d.svg";